import React from 'react';
import style from './card.module.css'
const Card = ({title,text}) => {

    return (
        <div className={style.mainBlock}>
            <div className={style.titleBlock}>
                <h1>{title}</h1>
            </div>
            <div>
                <h2>{text}</h2>
            </div>
        </div>
);
};

export default Card;